var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BfwComponent',{attrs:{"isReady":_vm.isReady,"title":_vm.title,"showTitle":_vm.showTitle,"editable":_vm.editable,"hideCard":false,"loaderType":"list-item"}},[_c('div',{staticClass:"chart-area"},[_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.chartOptions,"autoresize":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }